/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 12/01/2025
 * @update 12/01/2025
 * @file src/components/W17/W17F2180
 */

import { Button, Col, DatePicker, Dropdown, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, TextInput } from 'diginet-core-ui/components';
import PropTypes from "prop-types";
import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as W17F2180Actions from "../../actions/w17/w17F2180/w17F2180-actions";
import Config from "../../config";
import MForm from "../common/form/form";
import { Loading } from "../common/loading/loading";

const W17F2180Jobs = (props) => {
    const { dataInfo, handleOpen, dataCboJobsType } = props;
    const [loading, setLoading] = useState(false);
    const [cboJobsTypeLoading, setCboJobsTypeLoading] = useState(false);
    const [error, setError] = useState({});
    const [dataMaster, setDataMaster] = useState({
        Title: '',
        Notes: '',
        JobsType: '',
        StartTime: Config.convertDate(new Date()),
        EndTime: Config.convertDate(new Date()),
    });

    useEffect(() => {
        if (Config.isEmpty(dataCboJobsType)) getCboJobsType();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getCboJobsType = () => {
        setCboJobsTypeLoading(true);
        props.W17F2180Actions.getCboJobsType((error) => {
            setCboJobsTypeLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            }
        });
    };

    const checkValidateMaster = (arrName) => {
        if (Config.isEmpty(arrName)) return;
        return arrName.map(item => {
            let val = dataMaster[item];
            return {
                name: item,
                rules: ["isRequired"],
                value: val
            }
        });
    };

    const onSave = () => {
        const { JobsDate: JobsTime = null, EmployeeID = '', CustomerIDArr: CustomerID = [] } = dataInfo;
        const { Title = '', Notes = '', JobsType = '', StartTime = null, EndTime = null } = dataMaster;
        const params = {
            Title,
            Notes,
            JobsType,
            StartTime,
            EndTime,
            CustomerID,
            EmployeeID,
            JobsTime
        };
        const requiredField = ['Title', 'Notes'];
        const resultValidate = checkValidateMaster(requiredField);
        const validateFrom = MForm.formValidation(resultValidate);
        if (Object.keys(validateFrom).length > 0) {
            setError(validateFrom);
            return false;
        }
        setLoading(true);
        props.W17F2180Actions.createJobs(params, (error, data) => {
            setLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) {
                    Config.notify.show('success', Config.lang('Luu_thanh_cong'), 2000);
                    handleOpen && handleOpen(false, true); // Đóng Pop
                } else {
                    if (data?.Message) Config.popupCore.show('INFO', data.Message);
                }
            }
        });
    };

    const onChange = (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        let value = e?.value ?? e?.target?.value ?? '';
        if (['StartTime', 'EndTime'].includes(fieldName) && Config.isEmpty(value)) value = null;
        setDataMaster({ ...dataMaster, [fieldName]: value });
        if (error[fieldName] && !Config.isEmpty(value)) {
            setError({ ...error, [fieldName]: '' });
        }
    };

    return (
        <Modal
            open
            size={'sm'}
            onClose={() => handleOpen(false)} >
            <ModalHeader>{Config.lang('Phan_tuyen')}</ModalHeader>
            <ModalBody>
                <Row>
                    {loading && <Loading />}
                    <Col xs={3}><Label required type={'h4'}>{Config.lang('Tieu_de')}</Label></Col>
                    <Col xs={9}><TextInput viewType={'outlined'} value={dataMaster?.Title} onChange={(e) => onChange('Title', e)} error={error && error['Title']} /></Col>
                    <Col xs={3}><Label required type={'h4'}>{Config.lang('Mo_ta')}</Label></Col>
                    <Col xs={9}><TextInput multiline maxRows={5} viewType={'outlined'} value={dataMaster?.Notes} onChange={(e) => onChange('Notes', e)} error={error && error['Notes']} /></Col>
                    <Col xs={3}><Label type={'h4'}>{Config.lang('Loai_cong_viec')}</Label></Col>
                    <Col xs={9}>
                        <Dropdown
                            clearAble
                            dataSource={dataCboJobsType || []}
                            valueExpr={'TaskType'}
                            displayExpr={'TaskTypeName'}
                            viewType={'outlined'}
                            value={dataMaster?.JobsType}
                            loading={cboJobsTypeLoading}
                            onChange={e => onChange('JobsType', e)}
                        />
                    </Col>
                    <Col xs={3}><Label type={'h4'}>{Config.lang('Thoi_gian_bat_dau')}</Label></Col>
                    <Col xs={9}>
                        <DatePicker
                            clearAble
                            useDateInput
                            viewType={'outlined'}
                            displayFormat={"DD/MM/YYYY"}
                            max={dataMaster.EndTime}
                            value={dataMaster.StartTime}
                            onChange={e => onChange('StartTime', e)}
                        />
                    </Col>
                    <Col xs={3}><Label type={'h4'}>{Config.lang('Thoi_gian_ket_thuc')}</Label></Col>
                    <Col xs={9}>
                        <DatePicker
                            clearAble
                            useDateInput
                            viewType={'outlined'}
                            displayFormat={"DD/MM/YYYY"}
                            min={dataMaster.StartTime}
                            value={dataMaster.EndTime}
                            onChange={e => onChange('EndTime', e)}
                        />
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <div className={'jus-end'}>
                    <Button
                        color={'info'}
                        startIcon={'Save'}
                        className={"mgl1x"}
                        viewType={'filled'}
                        label={Config.lang('Luu')}
                        onClick={() => onSave()}
                    />
                </div>
            </ModalFooter>
        </Modal>
    );
}

W17F2180Jobs.defaultProps = {
    open: false,
    dataInfo: {},
    dataCboJobsType: [],
};

W17F2180Jobs.propTypes = {
    open: PropTypes.bool,
    dataInfo: PropTypes.object,
    dataCboJobsType: PropTypes.array,
    handleOpen: PropTypes.func
};

export default connect(state => ({
    dataCboJobsType: state.w17f2180.dataCboJobsType,
}), (dispatch) => ({
    W17F2180Actions: bindActionCreators(W17F2180Actions, dispatch),
}))(W17F2180Jobs);